/**
 * Description:配置管理 Api
 * Created by wxy on 2018/11/14
 */
import request from '@/utils/request'
const baseUrl = '/personal'

const configList = () => request({
  url: `${baseUrl}/config/getConfig`,
  method: 'POST'
})

// const addConfig = (data) => request({
//   url: `${baseUrl}/config/add`,
//   method: 'POST',
//   data
// })

const updateConfig = (data) => request({
  url: `${baseUrl}/config/saveConfig`,
  method: 'POST',
  data
})

const getLogo = (data) => request({
  url: `${baseUrl}/config/getLogoConfig`,
  method: 'POST',
  data
})

// const removeConfig = (data) => request({
//   url: `${baseUrl}/config/remove`,
//   method: 'POST',
//   data
// })

export {
  configList,
  // addConfig,
  updateConfig,
  getLogo
  // removeConfig,
}



// WEBPACK FOOTER //
// ./src/api/systemManagement/configurationApi.js